import { Observable } from "rxjs/Observable";
import { IAPIResponse, WeGoConfig, DataListModel } from "../../shared/config";
import { RequestOptions, Http, Headers } from "@angular/http";
import { Injectable } from "@angular/core";
import { AuthService } from "../../shared/models/auth.service";
import { RoleAvailabilityModel } from "./roleavailability.model"


@Injectable()
export class RoleAvailabilityService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetAllRoleAvailability(input?: DataListModel, customerHashId?: string): Observable<IAPIResponse> {
    let getRoleAvailabilityListUrl = WeGoConfig.API_GET_ROLEAVAILABILITY_LIST + "?customerHashID=" + customerHashId;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getRoleAvailabilityListUrl = getRoleAvailabilityListUrl + "&" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getRoleAvailabilityListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetRoleAvailabilityByHashId(roleAvailabilityHashID: string): Observable<IAPIResponse> {
    let getRoleAvailabilityUrl = WeGoConfig.API_GET_ROLEAVAILABILITY_BY_HASH + "?roleAvailabilityHashID=" + roleAvailabilityHashID;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getRoleAvailabilityUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateRoleAvailability(roleAvailability: RoleAvailabilityModel): Observable<IAPIResponse> {
    let body = roleAvailability;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_ROLEAVAILABILITY_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteRoleAvailability(roleAvailabilityHashId: string): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.get(WeGoConfig.API_POST_DELETE_ROLEAVAILABILITY + "?roleAvailabilityHashIds=" + roleAvailabilityHashId, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportRoleAvailability(input?: DataListModel, customerHashId?: string): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getUrl = WeGoConfig.API_EXPORT_ROLEAVAILABILITY_LIST + "?customerHashID=" + customerHashId + "&" + queryString;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getUrl, options);
  }

  public GetRoleForAssignToCustomer(input?: DataListModel, customerHashId?: string): Observable<IAPIResponse> {
    let getRoleToAssignListUrl = WeGoConfig.API_GET_ROLE_FOR_ASSIGN_TO_CUSTOMER_LIST + "?customerHashID=" + customerHashId;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getRoleToAssignListUrl = getRoleToAssignListUrl + "&" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getRoleToAssignListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddRoleAvailability(roleAvailabilityList: RoleAvailabilityModel[]): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.post(WeGoConfig.API_POST_ADD_ROLEAVAILABILITY, roleAvailabilityList, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/roleavailability/models/roleavailability.service.ts